import(/* webpackMode: "eager" */ "/app/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/ApolloNextAppProvider.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@apollo/experimental-nextjs-app-support/dist/ssr/hooks.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@stadionhq-v3/base-ui/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@stadionhq-v3/contentful-ui/index.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/@stadionhq-v3/football-ui/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/dynamic-bailout-to-csr.js");
;
import(/* webpackMode: "eager" */ "/app/node_modules/next/dist/shared/lib/lazy-dynamic/preload-css.js");
;
import(/* webpackMode: "eager" */ "/app/public/images/Leeds-United-Teams.png");
;
import(/* webpackMode: "eager", webpackExports: ["SessionProvider"] */ "/app/src/auth/SessionProvider.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/atoms/fixture-alert-header/fixtureAlertHeader.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/app/[locale]/layout.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/atoms/localized-date/localizedDate.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/atoms/preview-banner/previewBanner.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/helpers/article-card-renderer/articleCardRenderer.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default","derivePageType"] */ "/app/src/components/helpers/auto-page-view/autoPageView.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/helpers/contentful-rich-text-render/contentfulRichTextRender.component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/icons/flag/flag.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/broadcasters-wrapper/broadcastersWrapper.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderSponsorProvider"] */ "/app/src/components/organisms/site-nav/headerSponsorContext.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/organisms/site-nav/siteNav.component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/atoms/button/button.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["TextButton"] */ "/app/src/components/v3/atoms/button/variants/text-button/text-button.component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/embed-block/embedBlock.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/v3/organisms/fixture-card-slotted/fixtureCardSlotted.component.tsx");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/pull-quote-embed/pullQuoteEmbed.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/gallery-embed/galleryEmbed.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/image-embed/imageEmbed.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/organisms/fixtures-summary-block-match-card/fixturesSummaryBlockMatchCard.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/organisms/fixture-summary-block-league-table/fixtureSummaryBlockLeagueTable.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/molecules/gateway-card/gatewayCard.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/molecules/promo-card/promoCard.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/atoms/date/date.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/atoms/category-link/categoryLink.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/molecules/article-card/articleCard.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/molecules/author/author.module.scss");
;
import(/* webpackMode: "eager" */ "/app/src/components/v3/molecules/image-with-attribution/imageWithAttribution.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/components/v3/organisms/video-embed/videoEmbed.component.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsProvider"] */ "/app/src/providers/analytics/analytics.context.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/providers/gamification/gamification.provider.tsx");
